import React, { createContext, useState } from "react";
import { formatDate } from "../../../../utils/formatDate";

const PrescricaoContext = createContext();

const PrescricaoContextProvider = ({ children }) => {
  const [prescricaoId, setPrescricaoId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [expanded, setExpanded] = useState({ gerais: true });
  const [modalPrescriptionOpen, setModalPrescriptionOpen] = useState(false);
  const [dataColabTable, setDataColabTable] = useState([]);

  //Gerais
  const [clienteFilter, setClienteFilter] = useState(null);
  const [colaboradorFilter, setcolaboradorFilter] = useState(null);
  const [addColabOpen, setAddColabOpen] = useState(false);
  const [colaboradorSelected, setColaboradorSelected] = useState([]);
  //Produto
  const [localFilter, setLocalFilter] = useState(null);
  const [produtoLenteCodigo, setProdutoLenteCodigo] = useState(null);
  const [produtoLenteDescricaoSelected, setProdutoLenteDescricaoSelected] =
    useState(null);
  const [produtoAroCodigo, setProdutoAroCodigo] = useState(null);
  const [produtoAroDescricaoSelected, setProdutoAroDescricaoSelected] =
    useState(null);

  //Lente
  const [lenteTipoSelected, setLenteTipoSelected] = useState(null);
  const [lenteTratamentoSelected, setLenteTratamentoSelected] = useState(null);
  const [lenteReflexoSelected, setLenteReflexoSelected] = useState(null);
  const [lenteRiscoSelected, setLenteRiscoSelected] = useState(null);
  const [lenteODEsf, setLenteODEsf] = useState("");
  const [lenteODCili, setLenteODCili] = useState("");
  const [lenteODEixo, setLenteODEixo] = useState("");
  const [lenteODDNP, setLenteODDNP] = useState("");
  const [lenteOEEsf, setLenteOEEsf] = useState("");
  const [lenteOECili, setLenteOECili] = useState("");
  const [lenteOEEixo, setLenteOEEixo] = useState("");
  const [lenteOEDNP, setLenteOEDNP] = useState("");
  const [lenteAdicao, setLenteAdicao] = useState("");
  const [lenteAltura, setLenteAltura] = useState("");
  const [lenteSelected, setLenteSelected] = useState({
    label: "Par",
    id: "P",
  });

  //Aro
  const [aroCor, setAroCor] = useState("");
  const [aroTamanho, setAroTamanho] = useState("0");
  const [aroAjuste, setAroAjuste] = useState(null);
  const [aroHaste, setAroHaste] = useState(null);
  const [aroFrente, setAroFrente] = useState(null);

  //ModalColab
  const [colabNome, setColabNome] = useState("");
  const [colabEmail, setColabEmail] = useState("");
  const [colabCPF, setColabCPF] = useState("");
  const [colabRG, setColabRG] = useState("");
  const [colabActive, setColabActive] = useState(true);
  const [colabId, setColabId] = useState(null);

  //Geral
  let date = new Date();
  const [precricaoDataValidade, setPrecricaoDataValidade] = useState(
    formatDate({
      date: new Date(date.getFullYear() + 1, date.getMonth(), date.getDate()),
      separator: "-",
      format: "yyyy-mm-dd",
    })
  );
  const [receitaTObs, setReceitaTObs] = useState("");
  const [facePhotos, setFacePhotos] = useState([]);
  const [precricaoArquivo, setPrecricaoArquivo] = useState([]);
  const [autoVariais, setAutoVariavies] = useState([]);

  return (
    <PrescricaoContext.Provider
      value={{
        prescricaoId,
        setPrescricaoId,
        loading,
        setLoading,
        expanded,
        setExpanded,
        modalPrescriptionOpen,
        setModalPrescriptionOpen,
        dataColabTable,
        setDataColabTable,

        clienteFilter,
        setClienteFilter,
        colaboradorFilter,
        setcolaboradorFilter,
        addColabOpen,
        setAddColabOpen,
        colaboradorSelected,
        setColaboradorSelected,

        localFilter,
        setLocalFilter,
        produtoLenteCodigo,
        setProdutoLenteCodigo,
        produtoLenteDescricaoSelected,
        setProdutoLenteDescricaoSelected,
        produtoAroCodigo,
        setProdutoAroCodigo,
        produtoAroDescricaoSelected,
        setProdutoAroDescricaoSelected,

        lenteTipoSelected,
        setLenteTipoSelected,
        lenteTratamentoSelected,
        setLenteTratamentoSelected,
        lenteReflexoSelected,
        setLenteReflexoSelected,
        lenteRiscoSelected,
        setLenteRiscoSelected,
        lenteODEsf,
        setLenteODEsf,
        lenteODCili,
        setLenteODCili,
        lenteODEixo,
        setLenteODEixo,
        lenteODDNP,
        setLenteODDNP,
        lenteOEEsf,
        setLenteOEEsf,
        lenteOECili,
        setLenteOECili,
        lenteOEEixo,
        setLenteOEEixo,
        lenteOEDNP,
        setLenteOEDNP,
        lenteAdicao,
        setLenteAdicao,
        lenteAltura,
        setLenteAltura,
        lenteSelected,
        setLenteSelected,

        aroCor,
        setAroCor,
        aroTamanho,
        setAroTamanho,
        aroAjuste,
        setAroAjuste,
        aroHaste,
        setAroHaste,
        aroFrente,
        setAroFrente,

        colabNome,
        setColabNome,
        colabEmail,
        setColabEmail,
        colabCPF,
        setColabCPF,
        colabRG,
        setColabRG,
        colabActive,
        setColabActive,
        colabId,
        setColabId,

        precricaoDataValidade,
        setPrecricaoDataValidade,
        receitaTObs,
        setReceitaTObs,
        facePhotos,
        setFacePhotos,
        precricaoArquivo,
        setPrecricaoArquivo,
        autoVariais,
        setAutoVariavies,
      }}
    >
      {children}
    </PrescricaoContext.Provider>
  );
};

export { PrescricaoContextProvider, PrescricaoContext };
